module.exports = __webpack_public_path__ + "static/media/sel.38ff1571.png";